import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const {t} = useTranslation();
  return (
    <footer style={{ marginTop: "50px" }}>
      <div className="container-fluid">
        <div className="row justify-content-center py-5">
          {/* Contact Section */}
          <div className="col-12 text-center mb-4">
            <h5 className="mb-4 fw-bold">{t('nav.contactUs')}</h5>
            <div className="d-flex flex-wrap justify-content-center gap-5">
              <div className="contact-item d-flex align-items-start">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="contact-icon me-3"
                  title="info@mylegals.ca"
                  style={{ fontSize: "1.2rem" }}
                />
                <a
                  href="mailto:info@mylegals.ca"
                  className="text-decoration-none text-dark hover-link"
                >
                  info@mylegals.ca
                </a>
              </div>
              <div className="contact-item d-flex align-items-start">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="contact-icon me-3"
                  title="(416) 299-6668"
                  style={{ fontSize: "1.2rem" }}
                />
                <a
                  href="tel:+14162996668"
                  className="text-decoration-none text-dark hover-link"
                >
                  (416) 299-6668
                </a>
              </div>
              <div className="contact-item d-flex align-items-start">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="contact-icon me-3"
                  title="Scarborough, ON"
                  style={{ fontSize: "1.2rem" }}
                />
                <span className="text-dark">
                  Unit 2A31, 4675 Steeles Ave. E<br />
                  Scarborough, ON M1V 0B7
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-dark text-center py-3">
        <p className="copyright mb-0 text-white">
          ©2025 M&Y Legal Services
        </p>
      </div>
    </footer>
  );
};

export default Footer;